import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getLaborDetail, editLabor } from '../../../actions/laborsActions'
import { getCrops } from '../../../actions/cropsActions'
import FormLabor from '../../admin/labors/FormLabor'
import Swal from 'sweetalert2'

export default function LaborEdit() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {labor} = useSelector(state=>state.labors)
    const {crops} = useSelector(state=>state.crops)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, description, cropslist, require_machinery, idLabor} = formState
    const [imageAux, setImage] = useState(null)

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

	const changeImage = (e) => {
		setImage(e.target.files[0])
	}

    const handleEdit = async(e) => {
        e.preventDefault()

        dispatch(editLabor(name, description, cropslist, require_machinery, imageAux, idLabor))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('labors.messageedit')
        })
    }

    useEffect(()=>{
        dispatch(getLaborDetail(id))
        dispatch(getCrops())
    }, [dispatch,id])

    useEffect(() => {
        if (labor) {
            setFormState({
                name: labor.name,
                description: labor.description,
                cropslist: labor.crops,
                require_machinery: labor.require_machinery,
                idLabor: labor._id
            })
			setImage(labor.image)
        }
    }, [labor, dispatch, id])

    const handleCheckboxChange  = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.checked
        })
    }
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/labors`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('labors.volver')}
                    </Button>
                </Row>
                <h1>{t('labors.name')}: <span className='text-uppercase'>{labor?.name}</span></h1>
                <FormLabor submit={handleEdit} isNew={false} inputChange={handleInputChange} handleCheckbox={handleCheckboxChange} changeImage={changeImage} imageAux={imageAux} state={formState} crops={crops}></FormLabor>
            </Row>
        </Container>
    )
}
